import { HTMLAttributes, useMemo } from 'react'
import SelectBox from '~components/ui/text-input/select-box'
import Pet from '~models/pet'
import usePetKinds from '~repositories/hooks/use-pet-kinds'

interface Props extends HTMLAttributes<HTMLDivElement> {
  species: string | null
  breed: string | null
  onSpeciesSelect: (species: string) => void
  onBreedSelect: (breed: string) => void
}

const PET_KINDS = Object.keys(Pet.Kinds) as Pet.Kinds[]

const PET_KINDS_DATA = PET_KINDS.map(petType => ({
  label: petType,
  value: petType,
}))

const getBreedData = (breedList: Pet.Kind[] | undefined) =>
  breedList?.map(breed => ({
    label: breed.depth2 ?? '',
    value: breed.id ?? 0,
  }))

const PetType = ({ species, breed, onSpeciesSelect, onBreedSelect, ...props }: Readonly<Props>) => {
  const { data: breedList } = usePetKinds(species)

  const breedData = useMemo(() => getBreedData(breedList), [breedList])

  return (
    <div className={props.className}>
      <SelectBox className="w-full lg:w-full">
        <SelectBox.Input value={species} placeholder="Select species" />
        <SelectBox.Dropdown>
          <SelectBox.DropdownItemGroup
            data={PET_KINDS_DATA}
            onItemClick={item => onSpeciesSelect(item.label)}
          />
        </SelectBox.Dropdown>
      </SelectBox>

      {species && breedData && (
        <SelectBox className="mt-4 w-full lg:w-full">
          <SelectBox.Input value={breed} placeholder="Select breed" />
          <SelectBox.Dropdown>
            <SelectBox.DropdownSearch />
            <SelectBox.DropdownItemGroup
              data={breedData}
              onItemClick={item => onBreedSelect(item.label)}
              className="max-h-[200px]"
            />
          </SelectBox.Dropdown>
        </SelectBox>
      )}
    </div>
  )
}

export default PetType
